import { useState } from "react";
import { Phone, X } from "lucide-react";

const SupportButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href="tel:3207068138"
      className="fixed bottom-6 right-6 z-50 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid="support-button"
    >
      {/* Pulse animation ring */}
      <div className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-20"></div>
      
      {/* Main button */}
      <div className={`
        relative flex items-center gap-3 px-5 py-3 rounded-full
        bg-gradient-to-r from-emerald-500 to-teal-500
        shadow-lg shadow-emerald-500/30
        transition-all duration-300 ease-out
        hover:shadow-xl hover:shadow-emerald-500/40
        hover:scale-105
        ${isHovered ? 'pr-6' : ''}
      `}>
        {/* Phone icon with animation */}
        <div className={`
          relative transition-transform duration-300
          ${isHovered ? 'rotate-12 scale-110' : ''}
        `}>
          <Phone className="w-5 h-5 text-white" />
          
          {/* Ringing effect */}
          <div className={`
            absolute -top-1 -right-1 w-2 h-2 rounded-full bg-white
            ${isHovered ? 'animate-ping' : 'hidden'}
          `}></div>
        </div>
        
        {/* Text */}
        <div className="flex flex-col">
          <span className="text-white/80 text-[10px] font-medium leading-tight">
            Assistenza
          </span>
          <span className="text-white text-sm font-bold tracking-wide">
            320 706 8138
          </span>
        </div>
        
        {/* Decorative gradient overlay */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
      </div>
      
      {/* Tooltip on hover */}
      <div className={`
        absolute bottom-full right-0 mb-2 px-3 py-1.5 
        bg-slate-900 text-white text-xs rounded-lg
        whitespace-nowrap
        transition-all duration-200
        ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}
      `}>
        Clicca per chiamare
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-slate-900"></div>
      </div>
    </a>
  );
};

export default SupportButton;
